import { ApiError } from '../shared.api';

interface ValidationIssue {
  path?: unknown;
  message: string;
}

function isValidationIssue(value: unknown): value is ValidationIssue {
  return typeof value === 'object' && value !== null && typeof (value as { message?: unknown }).message === 'string';
}

function describeIssue({ path, message }: ValidationIssue): string {
  return typeof path === 'string' && path !== '' ? `${path}: ${message}` : message;
}

/**
 * The server's own explanation of a refusal (e.g. "Wait 20 seconds before asking for another code"), never the raw JSON body.
 * A validation failure (`ZodValidationPipe`) carries "Validation failed" plus the fields at fault in `issues`; those are appended so the user sees which.
 */
export function apiErrorMessage(err: unknown): string | undefined {
  if (!(err instanceof ApiError) || typeof err.body !== 'object' || err.body === null) return undefined;
  const { message, issues } = err.body as { message?: unknown; issues?: unknown };
  if (typeof message !== 'string') return undefined;
  const described = Array.isArray(issues) ? issues.filter(isValidationIssue).map(describeIssue) : [];
  return described.length > 0 ? `${message} — ${described.join('; ')}` : message;
}
